import { BattlefrontMap, BattlefrontMapName } from './models'

export const MAPS: BattlefrontMap[] = [
  {
    map: 'S5_1/Levels/MP/Geonosis_01/Geonosis_01',
    name: BattlefrontMapName.Geonosis,
  },
  {
    map: 'S6_2/Geonosis_02/Levels/Geonosis_02/Geonosis_02',
    name: BattlefrontMapName.Geonosis,
  },
  {
    map: 'Levels/MP/Kamino_01/Kamino_01',
    name: BattlefrontMapName.Kamino,
  },
  {
    map: 'S7_1/Levels/Kamino_03/Kamino_03',
    name: BattlefrontMapName.Kamino,
  },
  {
    map: 'Levels/MP/Naboo_01/Naboo_01',
    name: BattlefrontMapName.Naboo,
  },
  {
    map: 'Levels/MP/Naboo_01/Naboo_01',
    name: BattlefrontMapName.NabooTheedPalace,
  },
  {
    map: 'Levels/MP/Naboo_02/Naboo_02',
    name: BattlefrontMapName.Naboo,
  },
  {
    map: 'Levels/MP/Naboo_02/Naboo_02',
    name: BattlefrontMapName.NabooPalaceHangar,
  },
  {
    map: 'S7_2/Levels/Naboo_03/Naboo_03',
    name: BattlefrontMapName.Naboo,
  },
  {
    map: 'Levels/MP/Kashyyyk_01/Kashyyyk_01',
    name: BattlefrontMapName.Kashyyyk,
  },
  {
    map: 'S7/Levels/Kashyyyk_02/Kashyyyk_02',
    name: BattlefrontMapName.Kashyyyk,
  },
  {
    map: 'S8/Felucia/Levels/MP/Felucia_01/Felucia_01',
    name: BattlefrontMapName.Felucia,
  },
  {
    map: 'S3/Levels/Kessel_01/Kessel_01',
    name: BattlefrontMapName.Kessel,
  },
  {
    map: 'S9_3/Scarif/Levels/MP/Scarif_02/Scarif_02',
    name: BattlefrontMapName.Scarif,
  },
  {
    map: 'Levels/MP/Tatooine_01/Tatooine_01',
    name: BattlefrontMapName.Tatooine,
  },
  {
    map: 'S9_3/Tatooine_02/Tatooine_02',
    name: BattlefrontMapName.Tatooine,
  },
  {
    map: 'Levels/MP/Yavin_01/Yavin_01',
    name: BattlefrontMapName.Yavin,
  },
  {
    map: 'Levels/MP/Hoth_01/Hoth_01',
    name: BattlefrontMapName.Hoth,
  },
  {
    map: 'S9_3/Hoth_02/Hoth_02',
    name: BattlefrontMapName.Hoth,
  },
  {
    map: 'S2/Levels/CloudCity_01/CloudCity_01',
    name: BattlefrontMapName.Bespin,
  },
  {
    map: 'S2_2/Levels/JabbasPalace_01/JabbasPalace_01',
    name: BattlefrontMapName.Tatooine,
  },
  {
    map: 'Levels/MP/Tatooine_01/Tatooine_01',
    name: BattlefrontMapName.TatooineMosEisley,
  },
  {
    map: 'S2_2/Levels/JabbasPalace_01/JabbasPalace_01',
    name: BattlefrontMapName.TatooineJabbasPalace,
  },
  {
    map: 'Levels/MP/Endor_01/Endor_01',
    name: BattlefrontMapName.Endor,
  },
  {
    map: 'S2_1/Levels/Endor_02/Endor_02',
    name: BattlefrontMapName.EndorEwokVillage,
  },
  {
    map: 'S8_1/Endor_04/Endor_04',
    name: BattlefrontMapName.EndorResearchStation9,
  },
  {
    map: 'Levels/MP/DeathStar02_01/DeathStar02_01',
    name: BattlefrontMapName.DeathStar2,
  },
  {
    map: 'Levels/MP/Jakku_01/Jakku_01',
    name: BattlefrontMapName.Jakku,
  },
  {
    map: 'S9/Jakku_02/Jakku_02',
    name: BattlefrontMapName.Jakku,
  },
  {
    map: 'Levels/MP/Takodana_01/Takodana_01',
    name: BattlefrontMapName.Takodana,
  },
  {
    map: 'S9/Takodana_02/Takodana_02',
    name: BattlefrontMapName.Takodana,
  },
  {
    map: 'Levels/MP/StarKiller_01/StarKiller_01',
    name: BattlefrontMapName.StarkillerBase,
  },
  {
    map: 'S9/StarKiller_02/StarKiller_02',
    name: BattlefrontMapName.StarkillerBase,
  },
  {
    map: 'S1/Levels/Crait_01/Crait_01',
    name: BattlefrontMapName.Crait,
  },
  {
    map: 'S1/Levels/Crait_01/Crait_01',
    name: BattlefrontMapName.CraitWIP,
  },
  {
    map: 'S9_3/Crait/Crait_02',
    name: BattlefrontMapName.Crait,
  },
  {
    map: 'S9/Paintball/Levels/MP/Paintball_01/Paintball_01',
    name: BattlefrontMapName.AjanKloss,
  },
  {
    map: 'S9_3/COOP_NT_MC85/COOP_NT_MC85',
    name: BattlefrontMapName.MC85StarCruiser,
  },
  {
    map: 'S9_3/COOP_NT_FOSD/COOP_NT_FOSD',
    name: BattlefrontMapName.FirstOrderStarDestroyer,
  },
  {
    map: 'Levels/Space/SB_DroidBattleShip_01/SB_DroidBattleShip_01',
    name: BattlefrontMapName.Ryloth,
  },
  {
    map: 'Levels/Space/SB_Kamino_01/SB_Kamino_01',
    name: BattlefrontMapName.Kamino,
  },
  {
    map: 'Levels/Space/SB_Fondor_01/SB_Fondor_01',
    name: BattlefrontMapName.Fondor,
  },
  {
    map: 'Levels/Space/SB_Endor_01/SB_Endor_01',
    name: BattlefrontMapName.Endor,
  },
  {
    map: 'Levels/Space/SB_Resurgent_01/SB_Resurgent_01',
    name: BattlefrontMapName.UnknownRegions,
  },
  {
    map: 'S1/Levels/Space/SB_SpaceBear_01/SB_SpaceBear_01',
    name: BattlefrontMapName.DQar,
  },
  {
    map: 'Levels/MP/Tatooine_01/Tatooine_01',
    name: BattlefrontMapName.TatooineMosEisley,
  },
  {
    map: 'S2_2/Levels/JabbasPalace_01/JabbasPalace_01',
    name: BattlefrontMapName.TatooineJabbasPalace,
  },
  {
    map: 'S7_2/Levels/Naboo_03/Naboo_03',
    name: BattlefrontMapName.RepublicVenator,
  },
  {
    map: 'S6_2/Geonosis_02/Levels/Geonosis_02/Geonosis_02',
    name: BattlefrontMapName.SeparatistDreadnought,
  },
  {
    map: 'S9/Jakku_02/Jakku_02',
    name: BattlefrontMapName.ResurgentStarDestroyer,
  },
]

export const UniqueMaps = (): string[] => {
  const uniqueMaps: string[] = []
  const map = new Map()
  for (const bfMap of MAPS) {
    if (!map.has(bfMap.map)) {
      map.set(bfMap.map, true)
      uniqueMaps.push(bfMap.map)
    }
  }

  return uniqueMaps
}